// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoneyRemoveIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "MoneyRemove/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.167 3.333H5.833c-2.5 0-4.166 1.25-4.166 4.167v2.967c0 .308.316.5.591.375a4.614 4.614 0 0 1 2.75-.342c2.192.392 3.8 2.425 3.742 4.65-.008.35-.058.692-.15 1.025-.067.258.142.5.408.5h5.159c2.5 0 4.166-1.25 4.166-4.167V7.5c0-2.917-1.666-4.167-4.166-4.167ZM10 12.083a2.084 2.084 0 1 1 .001-4.168A2.084 2.084 0 0 1 10 12.083Zm6.042-.416a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V8.333a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v3.334Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 11.667c-1 0-1.892.441-2.5 1.133A3.333 3.333 0 0 0 .833 15c0 .625.175 1.217.484 1.717a3.308 3.308 0 0 0 2.85 1.616c.841 0 1.608-.308 2.191-.833.259-.217.484-.483.659-.783.308-.5.483-1.092.483-1.717a3.332 3.332 0 0 0-3.333-3.333Zm1.333 4.65a.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183l-.442-.442-.458.458a.618.618 0 0 1-.442.184.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883l.459-.458-.442-.442a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l.442.441.417-.416a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-.417.417.442.441a.629.629 0 0 1 0 .884Z"
}));
export default MoneyRemoveIcon;